const SubsidiaryConsoleTypes = {
    SubsidiaryConsole_ACTION_START:"SubsidiaryConsole_ACTION_START",
    SubsidiaryConsole_FETCH_DATA:"SubsidiaryConsole_FETCH_DATA",
    SubsidiaryConsole_FETCH_DATA_FAILED:"SubsidiaryConsole_FETCH_DATA_FAILED",
    SubsidiaryConsole_ADD_DATA:"SubsidiaryConsole_ADD_DATA",
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
    set_payload: ""
}

const SubsidiaryConsoleReducer = (state=Initial_state, action) => {
    switch(action.type){
        case SubsidiaryConsoleTypes.SubsidiaryConsole_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case SubsidiaryConsoleTypes.SubsidiaryConsole_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload.data,
                set_payload: action.payload.set_payload
            }

        case SubsidiaryConsoleTypes.SubsidiaryConsole_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }

        default:
            return state;
    }
};

export default SubsidiaryConsoleReducer;